import { createApi } from "@reduxjs/toolkit/query/react";

import { createServiceBaseQuery } from "../../client/serviceBaseQuery";

// Each file is about 20 KB; anything near this is not one of ours.
const MAX_BYTES = 200_000;

// Straight to zeus rather than through the BFF: the bytes need no shaping, and zeus
// marks each response privately cacheable for a year, so the browser serves repeats.
export const skillArtService = createApi({
  reducerPath: "skillArtService",
  baseQuery: createServiceBaseQuery("zeusUri"),
  // A path names one drawing for good, so a held answer never goes stale.
  keepUnusedDataFor: 3600,
  endpoints: (builder) => ({
    getSkillArt: builder.query<string, string>({
      query: (imageUrl) => ({
        url: imageUrl,
        // The request carries the user's token, so it must not be sent on elsewhere.
        redirect: "error",
        responseHandler: async (response) => {
          const markup = await response.text();
          if (markup.length > MAX_BYTES) throw new Error("skill art too large");
          return markup;
        },
      }),
    }),
  }),
});

export const { useGetSkillArtQuery } = skillArtService;
